import {
  PROFILE_ADDRESSES_GET,
  PROFILE_DOCUMENTS_GET,
  PROFILE_DOC_FILES_GET,
} from '../actions/types';

export const initialState = {
  addresses: [],
  documents: [],
};

export const profile = (state = initialState, action) => {
  switch (action.type) {
    case PROFILE_DOC_FILES_GET._SUCCESS: {
      const { id } = action.doc;
      const index = state.documents.findIndex((v) => v.id === id);
      if (index >= 0) state.documents[index] = action.doc;
      return state;
    }
    case PROFILE_DOCUMENTS_GET._SUCCESS: {
      state.documents = action.documents;
      return state;
    }
    case PROFILE_ADDRESSES_GET._SUCCESS: {
      state.addresses = action.addresses;
      return state;
    }
    default:
      return state;
  }
};
